<template>
  <div class="bto-sb-widget bto-sb-widget-category bto-sb-category-print">
    <div class="bto-sb-widget bto-sb-widget-prematch">
      <div class="bto-sb-widget-title bto-sb-widget-nav-icon">
        <h3>{{t('StatusTipePrint.OddTypes')}}</h3>
        <ul class="bto-sb-widget-nav-icon">
          <li>
            <span class="bto-sb-category-print-all">
              <label class="bto-sb-form-switch">
                <input type="checkbox" @change="toggleSelectAll($event)">
                <span class="bto-sb-form-switch-slider"></span>
              </label>
              <label>{{t('Global.SelectAll')}}</label>
            </span>
          </li>
          <li>
            <a
              href="javascript:void(0);"
              :title="t('Public.Close')"
              class="bto-sb-widget-nav-icon-close"
              @click="closeOutrightsPrintPage()"
            ></a>
          </li>
        </ul>
      </div>
      <div class="bto-sb-widget-content">
        <div class="bto-sb-category-print-row bto-sb-category-print-nav">
          <div
            class="bto-sb-category-print-col"
            v-for="(market, idx) in outrights"
            :key="idx"
          >
            <label class="bto-sb-form-control bto-sb-form-control-checkbox">
              {{market.name}}
              <input type="checkbox" v-model="market.selected">
              <span class="bto-sb-form-control-indicator"></span>
            </label>
          </div>
        </div>
          <div class="bto-sb-category-print-row bto-sb-category-print-control">
            <div class="bto-sb-category-print-col">
              <h4>{{t('StatusTipePrint.PageLayout')}}</h4>
              <div class="bto-sb-form-select">
                <select v-model="layoutSetting">
                  <option :value="0">{{t('StatusTipePrint.PageLayout.Horizontal')}}</option>
                  <option :value="1">{{t('StatusTipePrint.PageLayout.Vertical')}}</option>
                </select>
                <div class="bto-sb-form-select-arrow"></div>
              </div>
            </div>
            <div class="bto-sb-category-print-col">
              <h4>{{t('StatusTipePrint.FontSize')}}</h4>
              <div class="bto-sb-form-select">
                <select v-model="fontSizeSetting">
                  <option :value="0">{{t('StatusTipePrint.FontSize.Normal')}}</option>
                  <option :value="1">{{t('StatusTipePrint.FontSize.Large')}}</option>
                </select>
                <div class="bto-sb-form-select-arrow"></div>
              </div>
            </div>
          </div>
          <div class="bto-sb-category-print-footer">
            <a
              style="opacity: 0;"
              href="javascript:void(0);"
              download="odds.xls"
              id="excelDownloadElement"
            ></a>
            <a
              class="bto-sb-form-btn"
              :class="{'loading-cursor': this.loadingCursor}"
              href="javascript:void(0);"
              :title="`${this.loadingCursor ? t('W.load') : t('W.downloadE')}`"
              @click="downloadExcel($event)"
            >
              {{t('StatusTipePrint.Excel')}}
            </a>
            <a
              class="bto-sb-form-btn"
              href="javascript:void(0);"
              title="Print odds"
              @click="printData($event)"
            >
              {{t('Public.Print')}}
            </a>
            <a
              class="bto-sb-form-btn"
              href="javascript:void(0);" :title="`${t('Public.Close')}`" @click="closeOutrightsPrintPage()"
            >
              {{t('Public.Close')}}
            </a>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import OutrightsPrintPage from './outrights-print-page';
  import { EventBus } from '../../../services/event-bus-service';
  import { chunkArray } from '../../../services/utils';
  import CategoryPrintMixin from '../category/category-print-mixin';

  export default {
    name: 'OutrightsPrintComponent',
    props: {
      tournamentData: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    data() {
      return {
        outrights: [],
      };
    },
    mixins: [CategoryPrintMixin],
    created() {
      this.outrights = JSON.parse(JSON.stringify(this.tournamentData.outrights));
    },
    methods: {
      closeOutrightsPrintPage() {
        EventBus.$emit('closeOutrightsPrintPage');
      },
      toggleSelectAll(event) {
        let toggleValue = event.target.checked;

        this.outrights.forEach(o => o.selected = toggleValue);
        this.outrights = Object.assign([], this.outrights);
      },
      async generatePrintPage() {
        const selectedMarkets = this.outrights.filter(o => o.selected);
        return new Promise((resolve, reject) => {
          if (!selectedMarkets.length) {
            reject('(print) no markets selected');
            return;
          }
          // chunk each outright outcomes into maxOutcesPerPage
          const tableRows = selectedMarkets.map(m => ({
            ...m,
            chunkedOutcomes: chunkArray(m.outcomes, this.maxOutcomesPerPage)
          }));

          const outrightsPrintPage = Vue.extend(OutrightsPrintPage);
          const outrightsPrintPageComp = new outrightsPrintPage({
            propsData: {
              maxOutcomesPerPage: this.maxOutcomesPerPage,
              sportName: this.sportName,
              logo: this.logo,
              tableRows
            },
          });
          resolve(outrightsPrintPageComp);
        });
      },
    },
  };
</script>
